import React, { useState, useRef } from 'react';
import { Image, Row, Col, List, Button } from 'antd';
import { useLocation, useNavigate, Link } from 'react-router-dom'
import moment from 'moment';
const IHealthPage = (props) => {
    const [visible, setVisible] = useState(false);
    const [url, setUrl] = useState('');

    React.useEffect(() => {


    }, [])
    function showImg(url,copywriting){
        if(copywriting==='下载图片'){
            setUrl(url)
            setVisible(true)
        }
       
    }




    return (
        <div style={{ display: props.isCustomer ? "none" : "", width: '100%',
        borderRadius: '10px', border: "1px file #F3F3F3" ,background:'#F3F3F3',padding:'10px',marginTop:'2px' }}>
            <Row style={{marginLeft:'17px'}}>
                <Col style={{ color: '#2657F9', fontSize: '20px' }}>
                    iHealth
                </Col>
                <Col style={{ color: '#000000', fontSize: '20px', marginLeft: '5px' }}>
                    replied
                </Col>
                <Image
                style={{
                    display: 'none'
                }}
                src={url}
                preview={{
                    visible,
                    scaleStep: '0.5',
                    onVisibleChange: (value) => {
                        setVisible(value);
                    },
                }}
            />
            </Row>
            <div style={{ color: 'rgba(0, 0, 0, 0.55)', fontSize: '14px', marginTop: '3px',marginLeft:'17px', height: '30px' }}>{props.day}</div>
            <div style={{ color: 'rgba(0, 0, 0, 0.85)', marginRight:'20px',fontSize: '16px', marginTop: '11px',marginLeft:'17px' }}>{props.comment}</div>
            <List
                style={{ marginRight: '30px', padding: '0px',marginTop:'10px' }}
                itemLayout="vertical"
                dataSource={props.filesList}
                renderItem={(item) => (
                        <Row style={{ height: '35px', }}>
                            <Col >
                                {item.img}
                            </Col>
                            <Col onClick={() => showImg(item.url, item.copywriting)} style={{ height: '24px', fontSize: '14px', color: '#3D3D3D' }}>
                                {item.name}
                            </Col>
                            <Col flex="auto" style={{ height: '24px', fontSize: '14px', color: '#3D3D3D', display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                                <Button className="btn" style={{ fontSize: '14px', paddingTop: '0px' }} onClick={() => downloadFile(item)} type="text">{item.copywriting}</Button>
                            </Col>
                        </Row>
                )}

            />
        </div>
    )
}
function downloadFile(data) {
    const url = data.url
    fetch(url, {
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        // 获取blob文件流
        return res.blob();
    }).then(blob => {
        let a = document.createElement('a');
        // 通过 blob 对象获取对应的 url
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = data.name;
        a.click();
        a.remove();
    })
}
function timestampToTime(timestamp) {
    // 时间戳为10位需*1000，时间戳为13位不需乘1000
    var date = new Date(timestamp * 1000);
    var Y = date.getFullYear() + "-";
    var M =
        (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h = date.getHours() + ":";
    var m = date.getMinutes() + ":";
    var s = date.getSeconds();
    return Y + M + D + h + m + s;
}
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px',
    }, itemLeftStyle: {
        marginLeft: '17px',
        width: '150px',
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.85)',
    }, itemRightStyle: {
        marginLeft: '15px',
        marginRight: '5px',
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.85)',
    },
}
export default IHealthPage;